var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mb-3"},[_c('p',{staticClass:"h3"},[_vm._t("title")],2),_c('div',{staticClass:"alert alert-primary",attrs:{"role":"alert"}},[_c('span',{staticClass:"fas fa-sad-tear h1 mr-2 align-middle"}),_vm._v(" "+_vm._s(_vm.translate("no-data-available."))+" ")]),_vm._t("buttons")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }